import { Box, Stack, Typography } from "@mui/material";
import react from "react";

export default function SectionHeader({ title, subtitle, action }) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      mb={2}
    >
      <Box>
        <Typography variant="h6" fontWeight={700} lineHeight={1.3}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {action && (
        <Box ml={1} flexShrink={0}>
          {action}
        </Box>
      )}
    </Stack>
  );
}
